import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { CommunityApiService } from 'features/community/api/community-api.service';
import { fieldsQueryKeys } from 'features/fields';
import { queryClient } from 'providers';
// ../api/social-api.service
// ../api/community-api.service
const { updateStatusCommunity } = CommunityApiService();

export const useUpdateStatusCommunity = () => {
  const { message } = App.useApp();

  return useMutation(
    (payload: any) => {
      return updateStatusCommunity(payload as any);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      onSuccess: (data, variables) => {
        Promise.all([
          queryClient.invalidateQueries({
            queryKey: fieldsQueryKeys.lists(),
          }),
          queryClient.invalidateQueries({
            queryKey: fieldsQueryKeys.detail(variables.id as any),
          }),
        ]);
        message.success('Update successfully');
      },
    },
  );
};
